import getBlockById from 'services/apiHelpers/getBlockById';
import { findByKeyVal_V2 } from 'services/findByKeyVal';
import getTopics from 'services/apiHelpers/getTopics';
import getStore from 'services/getStore';
import {
  addTopicPortalMedia as _addTopicPortalMedia_,
  removeTopicPortalMedia as _removeTopicPortalMedia_,
} from 'factories/interactions/topicportal';
import { setBlockAction } from 'actions/setBlockAction';
import { setBlocksAction } from 'actions/setBlocksAction';
import setNewBlockNewTree from 'services/apiHelpers/setNewBlockNewTree';
import { Block } from '@chameleoncreator/creator-app';

const addTopicPortalMedia = (topicPortalContainerBlock, index, props) => {
  const [newBlock, newTree] = _addTopicPortalMedia_(
    topicPortalContainerBlock,
    // topicPortalContainerBlock.children.length,
    index,
    props
  );

  if (newBlock === topicPortalContainerBlock) {
    return;
  }

  const store = getStore();

  if (newTree) {
    setNewBlockNewTree(newTree, newBlock, store, setBlocksAction);
  } else {
    store.dispatch(setBlockAction(newBlock));
  }
};

const removeTopicPortalMedia = (topicPortalContainerBlock, index) => {
  const [newBlock, newTree] = _removeTopicPortalMedia_(
    topicPortalContainerBlock,
    index
  );

  if (newBlock === topicPortalContainerBlock) {
    return;
  }

  const store = getStore();

  if (newTree) {
    setNewBlockNewTree(newTree, newBlock, store, setBlocksAction);
  } else {
    store.dispatch(setBlockAction(newBlock));
  }
};

export const updateTopicPortalMedia = (topics, blockId) => {
  const getTopicPortalContainerBlock = () => {
    return findByKeyVal_V2(blockId, 'type', 'TopicPortalContainer');
  };

  const getTopicPortalContainerBlockChildrenData = () => {
    return (getTopicPortalContainerBlock()?.children as []).map(
      (child: Block) => {
        const block = getBlockById(child.id);
        return block?.props?.topicId;
      }
    );
  };

  const addMedia = () => {
    topics.forEach((t, index) => {
      if (!getTopicPortalContainerBlockChildrenData().includes(t.id)) {
        // console.log('addTopicPortalMedia :', t.id);
        addTopicPortalMedia(getTopicPortalContainerBlock(), index, t.id);
      }
    });
  };

  const removeMedia = () => {
    getTopicPortalContainerBlockChildrenData().forEach((tId, index) => {
      const topicIds = topics
        .map(t => {
          return t.id;
        })
        .reduce((acc, curr) => {
          return {
            ...acc,
            [curr]: curr,
          };
        }, {});

      // if there's not a ' matching ' topic === topicPortalChild
      // remove that child
      if (!topicIds[tId]) {
        // console.log('removeTopicPortalMedia :', tId);
        removeTopicPortalMedia(getTopicPortalContainerBlock(), index);
      }
    });
  };

  return {
    addMedia,
    removeMedia,
  };
};
